module.exports = __webpack_public_path__ + "static/media/checkbox-uncheck.b48681d0.svg";